import { TextArea, Box, Text } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledTagSettingsFormContainer = styled(Box)`
  &&& {
    align-items: flex-start;
    justify-content: space-between;
    overflow-x: auto;
    padding: var(--cl-space-5) var(--cl-space-6);
    gap: var(--cl-space-4);
  }
`;

export const StyledLeftColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 47%;
  gap: var(--cl-space-4);
`;

export const StyledRightColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 48%;
  gap: var(--cl-space-4);
`;

export const StyledTextArea = styled(TextArea)`
  &&& {
    resize: vertical;
  }
`;

export const DrawerDescription = styled(Text)`
  &&& {
    line-height: 18px;
    color: var(--cl-gray-700);
  }
`;

export const DrawerLink = styled.a`
  &&& {
    text-transform: none;
    font-weight: normal;
    text-decoration: underline;
  }
`;
